/**
 * @class popupHelper.
 * @description  configurable helper wrapper for modals
 * @author Nutrafol Dev Team.
 * @link https://www.npmjs.com/package/@nutrafol/popup-helper
 * @since  Dec 2020
 */

var state = { open: false, scrollY: 0, activeElementWas: null, config: {} }
var touchHandler =  e => {if (e.touches.length > 1) {e.preventDefault()}}

var popupHelper = {
  /**
   **
   *   track activeElement when click opened a popup
   */
  trackActiveElement: () => {
    if (typeof document !== "undefined") {
      //debugger;
      document.addEventListener(
          "click",
          function(e) {
            /*
             * debugger;
             *  stop activeElementWas watch
             */
            if (state.open) {
              return
            }
            // persist activeElementWas
            e = e || window.event
            state.activeElementWas = e.target || e.srcElement
          },
          false
      )
    }
  },

  /**
   **
   * check if we are in  mobile layout
   * @returns {boolean}
   */
  isMobile: () => {
    return document.body.clientWidth < 768
  },

  /**
   * recursive parent lookup
   * @param el
   * @param id
   * @returns {Node|null}
   */
  findUpTag: (el, id) => {
    while (el.parentNode) {
      el = el.parentNode
      if (el.id === id) {
        return el
      }
    }
    return null
  },

  /**
   **
   * trap focus within popup
   * @param config
   */
  trapFocus(config) {
    /*
     * debugger;
     *  console.log('trapFocus')
     */
    var element = document.getElementById(config.wrapper)
    //.w-vulcan-v2-button is a wistia button placeholder we want to avoid in focusableEls
    var selectors = [
      "a[href]:not([disabled])",
      "button:not([disabled]):not(.w-vulcan-v2-button)",
      "textarea:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
    ]

    var focusableElsTemp = element.querySelectorAll(selectors.join(", "))
    var focusableEls = []

    // if we have 2 separate wrappers for desktop and mobile,  we need to narrow selection
    if (config.desktopEl || config.mobileEl) {
      if (config.closeEl) {
        focusableEls.push(document.getElementById(config.closeEl))
      }
      focusableElsTemp.forEach((el) => {
        if (
            config.desktopEl &&
            popupHelper.findUpTag(el, config.desktopEl) &&
            !popupHelper.isMobile()
        ) {
          focusableEls.push(el)
        }
        if (
            config.mobileEl &&
            popupHelper.findUpTag(el, config.mobileEl) &&
            popupHelper.isMobile()
        ) {
          focusableEls.push(el)
        }
      })
    } else {
      focusableEls = focusableElsTemp
    }

    var firstFocusableEl = focusableEls[0]
    var lastFocusableEl = focusableEls[focusableEls.length - 1]

    firstFocusableEl && firstFocusableEl.focus()

    //IOS: allow scroll only, disallow pinch zoom
    if (config.preventTouch && popupHelper.isMobile()) {
      document.addEventListener('touchmove', touchHandler, {passive: false})
    }
    let handler
    /*
     *  console.log('keydown', e)
     * ESC key on the keyboard should close the popup
     * adding check for key because chrome autocomplete is causing error
     */
    if (config.closeOnEscape) {
      handler = function (evt) {
        evt = evt || window.event
        var isEscape =
          !!evt &&
          !!evt.key &&
          (evt.key.indexOf("Esc") > -1 || evt.keyCode === 27)
        if (isEscape) {
          try {
            document.getElementById(config.closeEl).click()
          } catch (e) {}
          //popupHelper.onClose()
        }
      }
      document.addEventListener("keydown", handler)
    }

    // cycle over tab within element
    handler = function (e) {
      if (!!e && !!e.key) {
        var isTab = e.key === "Tab" || e.keyCode === 9
        if (isTab && firstFocusableEl && lastFocusableEl) {
          if (e.shiftKey) {
            /* shift + tab */
            if (document.activeElement === firstFocusableEl) {
              lastFocusableEl.focus()
              e.preventDefault()
            }
          } else {
            /* tab */
            if (document.activeElement === lastFocusableEl) {
              firstFocusableEl.focus()
              e.preventDefault()
            }
          }
        }
      }
    }
    document.addEventListener("keydown", handler)
  },

  /**
   **
   * on open modal, disable scroll, persist scrollY
   * @param config
   */

  onOpen: config => {
    //console.log('onOpen')

    if (config.wrapper) {
      let cnt = 0
      setTimeout(function waitPanelMainWrapper() {
        cnt++
        if (document.getElementById(config.wrapper)) {
          popupHelper.trapFocus(config)
          state.open = true
        } else {
          // wait for wrapper to appear for 10 seconds, than cancel trap
          if(cnt<100){
            setTimeout(waitPanelMainWrapper, 100)
          } else {
            console.log('wrapper not ready, canceling trap')
            state.open = true
          }
        }
      }, 100)
    } else {
      state.open = true
    }
    state.config = config
    if (config.fullScreenMobile && popupHelper.isMobile()) {
      document.body.style.width = "0px"
    }
    //popupHelper.disableScroll()
    config.closeOnEscape = typeof config.closeOnEscape === 'boolean' ? config.closeOnEscape : true;
  },

  /**
   **
   * on close modal, enable scroll, restore focus , restore scrollY
   */

  onClose: () => {

    if (state.activeElementWas) {
      setTimeout(() => {
        //debugger;
        state.activeElementWas.focus()
        state.open = false
      }, 250)
    }
    if (state.config && state.config.preventTouch && popupHelper.isMobile()) {
      document.removeEventListener('touchmove', touchHandler, {passive: false})
    }
    if (document.body.style.width === "0px") {
      document.body.style.width = "auto"
    }
    popupHelper.enableScroll()
  },

  /**
   **
   *  disable scroll and fix ios15 issue
   *  https://stackoverflow.com/questions/69589924/ios-15-minimized-address-bar-issue-with-fixed-position-full-screen-content
   */

  disableScroll: () => {
    popupHelper.scrollY = window.scrollY
    //html tag
    document.documentElement.style.height = '100vh'
    //body tag
    document.body.style.position = 'fixed'
    document.body.style.left = `0`
    document.body.style.right = `0`
    document.body.style.top = `-${popupHelper.scrollY}px`
    document.body.style.height = `100vh`

  },

  /**
   **
   * enable scroll and fix ios15 issue
   *
   */

  enableScroll: () => {
    //html tag
    document.documentElement.style.removeProperty('height')
    //body tag
    document.body.style.removeProperty('position')
    document.body.style.removeProperty('top')
    document.body.style.removeProperty('left')
    document.body.style.removeProperty('right')
    document.body.style.removeProperty('height')
    window.scrollTo(0, parseInt(popupHelper.scrollY))
  }
}

export default popupHelper